import React, { Component } from 'react'

class CallBox extends Component {
    render() {
        const { info } = this.props

        return (
            <div className="row call-box">
                <div className="col-lg-12 text-right sm-center">
                    <strong className="phone">
                        <a href={`tel:${info.phone.replace('+', '00').replace(' ', '')}`}>{info.phone}&nbsp;<i className="fas fa-phone"></i></a>
                    </strong><br/>
                    {info.opening && (<span className="opening">
                        {info.opening}
                    </span>)}
                </div>
            </div>
        )
    }
}

export default CallBox


// WEBPACK FOOTER //
// ./src/components/CallBox.js